export const lowerCaseValues = <T extends object>(obj: T): T => {
  return Object.entries(obj)
    .map(([key, value]) => [key, typeof value === 'string' ? value.toLowerCase() : value])
    .reduce((sum, [key, value]) => Object.assign(sum, { [key]: value }), {} as T)
}

export const isEmpty = (obj: object): boolean => Object.keys(obj).length === 0

export const isJsonObject = (value: string) => {
  if (!value) {
    return null
  }
  const parsedValue = JSON.parse(value)
  return typeof parsedValue === 'object' && !Array.isArray(parsedValue)
}

/**
 * Get object keys with their proper types instead of number.
 */
export function objectKeys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>
}
